import { CLOSE_PATIENT, PatientAction } from "store/types/patient.types";
import {
  Journal,
  JournalEntryContainerType,
  JournalEntryItemType,
  JournalEntryType,
  JournalType,
} from "model/journal.model";
import {
  JournalAction,
  RESET_JOURNAL,
  UPDATE_LIST_JOURNAL,
} from "../types/journal.types";
import _ from "lodash";

export interface JournalState extends JournalType {}

export const initialJournalState: JournalState = new Journal();

/** ---- SELECTORS ---- */
export const selectJournalEntryContainers = (
  state: JournalState
): Array<JournalEntryContainerType> => {
  return state.journalEntryContainers;
};

export const selectJournalEntries = (
  state: JournalState
): { [containerId: number]: Array<JournalEntryType> } => {
  return state.journalEntries;
};

export const selectJournalEntryItems = (
  state: JournalState
): Array<JournalEntryItemType> => {
  return state.journalEntryItems;
};

/** ---- ACTION HANDLERS ---- */
const clearJournal = () => {
  return new Journal();
};

const updateJournal = (state: JournalState, journal: JournalType) => {
  return {
    ...state,
    journalEntryContainers: _.unionBy(
      state.journalEntryContainers,
      journal.journalEntryContainers,
      (container: JournalEntryContainerType) => container.id
    ),
    journalEntries: { ...state.journalEntries, ...journal.journalEntries },
    journalEntryItems: _.unionBy(
      state.journalEntryItems,
      journal.journalEntryItems,
      (item: JournalEntryItemType) => item.id
    ),
    processedIds: _.union(state.processedIds, journal.processedIds),
  };
};

/** ---- REDUCER ---- */
export const journalReducer = (
  state = initialJournalState,
  action: JournalAction | PatientAction
): JournalState => {
  switch (action.type) {
    case CLOSE_PATIENT:
    case RESET_JOURNAL:
      return clearJournal();
    case UPDATE_LIST_JOURNAL:
      return updateJournal(state, action.payload);
    default:
      return state;
  }
};
